import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
export const RadioGroup = ({ label, options, value, error, disabled = false, onChange, direction = 'vertical', 'data-testid': testId, className, name, }) => {
    const theme = useTheme();
    const groupName = name || `radio-group-${Math.random().toString(36).substring(2, 11)}`;
    const errorId = error ? `${groupName}-error` : undefined;
    const handleChange = (optionValue, optionDisabled) => {
        if (!disabled && !optionDisabled && onChange) {
            onChange(optionValue);
        }
    };
    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.sm,
    };
    const groupLabelStyles = {
        fontSize: theme.typography.fontSize.small,
        fontWeight: theme.typography.fontWeight.medium,
        color: error ? theme.colors.error : theme.colors.text,
        marginBottom: theme.spacing.xs,
    };
    const optionsContainerStyles = {
        display: 'flex',
        flexDirection: direction === 'horizontal' ? 'row' : 'column',
        gap: direction === 'horizontal' ? theme.spacing.md : theme.spacing.sm,
        flexWrap: 'wrap',
    };
    const optionContainerStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.sm,
        cursor: 'pointer',
    };
    const radioStyles = {
        width: '20px',
        height: '20px',
        cursor: 'pointer',
        accentColor: theme.colors.primary,
    };
    const labelTextStyles = {
        fontSize: theme.typography.fontSize.body,
        color: theme.colors.text,
        fontFamily: theme.typography.fontFamily,
        userSelect: 'none',
    };
    const errorStyles = {
        fontSize: theme.typography.fontSize.caption,
        color: theme.colors.error,
        marginTop: theme.spacing.xs,
    };
    return (_jsxs("div", { style: containerStyles, className: className, "data-testid": testId, role: "radiogroup", "aria-labelledby": label ? `${groupName}-label` : undefined, "aria-describedby": errorId, "aria-invalid": !!error, children: [label && (_jsx("div", { id: `${groupName}-label`, style: groupLabelStyles, children: label })), _jsx("div", { style: optionsContainerStyles, children: options.map((option) => {
                    const isDisabled = disabled || option.disabled;
                    const radioId = `${groupName}-${option.value}`;
                    return (_jsxs("label", { htmlFor: radioId, style: {
                            ...optionContainerStyles,
                            opacity: isDisabled ? 0.6 : 1,
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                        }, children: [_jsx("input", { type: "radio", id: radioId, name: groupName, value: option.value, checked: value === option.value, disabled: isDisabled, onChange: (e) => handleChange(e.target.value, option.disabled), style: radioStyles }), _jsx("span", { style: labelTextStyles, children: option.label })] }, option.value));
                }) }), error && (_jsx("div", { id: errorId, role: "alert", style: errorStyles, children: error }))] }));
};
RadioGroup.displayName = 'RadioGroup';
